export default {
  route: {
    dashboard: 'Gösterge Paneli',
    documentation: 'Dokümantasyon',
    guide: 'Rehber',
    permission: 'İzinler',
    pagePermission: 'Sayfa İzni',
    rolePermission: 'Rol İzni',
    directivePermission: 'Direktif İzni',
    icons: 'İkonlar',
    components: 'Bileşenler',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editörü',
    splitPane: 'Bölünmüş Panel',
    avatarUpload: 'Avatar Yükle',
    dropzone: 'Dropzone',
    sticky: 'Yapışkan',
    countTo: 'Sayaç',
    componentMixin: 'Bileşen Karışımı',
    backToTop: 'Yukarı Çık',
    draggableDialog: 'Sürüklenebilir Diyalog',
    draggableKanban: 'Sürüklenebilir Kanban',
    draggableList: 'Sürüklenebilir Liste',
    draggableSelect: 'Sürüklenebilir Seçim',
    charts: 'Grafikler',
    barChart: 'Çubuk Grafik',
    lineChart: 'Çizgi Grafik',
    mixedChart: 'Karma Grafik',
    example: 'Örnek',
    nested: 'İç İçe Rotalar',
    menu1: 'Menü 1',
    'menu1-1': 'Menü 1-1',
    'menu1-2': 'Menü 1-2',
    'menu1-2-1': 'Menü 1-2-1',
    'menu1-2-2': 'Menü 1-2-2',
    'menu1-3': 'Menü 1-3',
    menu2: 'Menü 2',
    table: 'Tablo',
    dynamicTable: 'Dinamik Tablo',
    draggableTable: 'Sürüklenebilir Tablo',
    inlineEditTable: 'Satır İçi Düzenleme Tablosu',
    complexTable: 'Karmaşık Tablo',
    tab: 'Sekme',
    form: 'Form',
    createArticle: 'Makale Oluştur',
    editArticle: 'Makale Düzenle',
    articleList: 'Makale Listesi',
    errorPages: 'Hata Sayfaları',
    page401: '401',
    page404: '404',
    errorLog: 'Hata Kaydı',
    excel: 'Excel',
    exportExcel: 'Excel Dışa Aktar',
    selectExcel: 'Seçileni Dışa Aktar',
    mergeHeader: 'Başlığı Birleştir',
    uploadExcel: 'Excel Yükle',
    zip: 'Zip',
    exportZip: 'Zip Dışa Aktar',
    theme: 'Tema',
    clipboard: 'Pano',
    i18n: 'Uluslararasılaştırma',
    externalLink: 'Harici Bağlantı',
    wewalkPage: 'WeWALK',
    profile: 'Profil',
    mobility: 'Mobilite',
    addTrainerTrainee: 'Eğitmen/Eğitim Alanı Ekle',
    listOrEditTrainerTrainee: 'Eğitmen/Eğitim Alanlarını Listele/Düzenle',
    danis: 'Danış',
    danisconfig: 'Danış Ayarları',
    freeZone: 'Serbest Bölge',
    company: 'Şirketler',
    packageManagment: 'Paket Yönetimi',
    assistantConfig: 'Asistan Ayarları',
    navigationConfig: 'Navigasyon Ayarları',
    appSettings: 'Uygulama Ayarları',
    placesProvider: 'Mekan Servisi',
    placesCompare: 'Servis Karşılaştırma',
    mcp: 'MCP Erişimi',
    configs: 'Ayarlar',
    storeVersion: 'Mağaza Sürümleri',
    contracts: 'Sözleşmeler',
    contractManagement: 'Sözleşme Yönetimi',
    userActivations: 'Kullanıcı Aktivasyonları',
    callEvents: 'Çağrı Etkinlikleri',
    sessions: 'Oturumlar',
    subject: 'Konu',
    brand: 'Marka',
    brandSubject: 'Marka Konusu',
    entitlements: 'Yetkilendirmeler',
    features: 'Özellikler',
    devices: 'Cihazlar',
    userEntitlements: 'Kullanıcı Yetkileri',
    purchases: 'Satın Almalar',
    entitlementProducts: 'Yetkilendirme Ürünleri',
    analytics: 'Analitik',
    businessAnalytics: 'İş Analitiği',
    kpiAnalytics: 'KPI Analitiği',
    referrals: 'Davet Programı',
    zoho: 'Zoho Entegrasyonu',
    storeDashboard: 'Mağaza Paneli',
    subscriptionEvents: 'Abonelik Olayları',
    webhookLogs: 'Webhook Kayıtları',
    voiceAssistant: 'Sesli Asistan',
    entitlementRules: 'Yetkilendirme Kuralları',
    subscriptionSystem: 'Abonelik Sistemi',
    mobile: 'Uygulama Yerelleştirme',
    applocalizations: 'Uygulama Dilleri',
    applocalizations_detail: 'Yerelleştirme Detayı',
    appcoupons: 'Kupon Kodları',
    users: 'Kullanıcılar',
    listUser: 'Listele',
    activations: 'Baston Aktivasyonları',
    authEvents: 'Kimlik Doğrulama Olayları',
    otafiles: 'Ota Dosyaları',
    betaGroups: 'Beta Grupları',
    caneAudioPacks: 'Baston Ses Paketleri',
    'redirect-weassist': 'WeAssist Panel Giriş',
    callLogs: 'Çağrı Kayıtları',
    bulkGrantCleanup: 'Bulk Grant Temizliği',
    subscriptionAudit: 'Abonelik Denetimi',
    aimAnalytics: 'AIM Analitik',
    diagnostics: 'Baston Tanılama',
    adminUsers: 'Kullanıcı Oluştur',
    appleNotifications: 'Apple Bildirimleri',
    savedRoutes: 'Kayıtlı Rotalar',
    pdf: 'PDF',
    notifications: 'Bildirimler',
    notificationLogs: 'Bildirim Kayıtları',
    pendingGrants: 'Bekleyen Tanımlar',
    skuManagement: 'SKU Yönetimi',
    warrantyPeriods: 'Garanti Süreleri',
    campaigns: 'Kampanyalar',
    monthlyCredits: 'Aylık Krediler',
    aimData: 'AIM Verileri',
    externalApiKeys: 'Harici API Anahtarları',
    bulkGrant: 'Toplu Tanimlama',
    reporting: 'Raporlama'
  },
  navbar: {
    logOut: 'Çıkış Yap',
    dashboard: 'Gösterge Paneli',
    github: 'Github',
    theme: 'Tema',
    size: 'Global Boyut',
    profile: 'Profil'
  },
  login: {
    title: 'WeWALK Yönetici',
    logIn: 'Giriş Yap',
    sendCode: 'Kodu Gönder',
    enterCode: 'Doğrulama Kodu',
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    any: 'herhangi biri',
    thirdparty: 'Veya ile bağlan',
    thirdpartyTips: 'Yerelde simüle edilemez, lütfen kendi iş simulasyonunuzu birleştirin!',
    timeUpResendCode: 'Süre Doldu, Kodu Yeniden Gönder',
    countryCode: 'Ülke Kodu',
    phoneNumber: 'Telefon Numarası',
    loginError: 'Giriş işleminde bir sorun oluştu. Lütfen tekrar deneyin veya sistem yöneticisi ile iletişime geçin.',
    loginErrorTitle: 'Hata!',
    loginWarningTitle: 'Uyarı!',
    invalidEmail: 'Lütfen geçerli bir e-posta adresi giriniz.',
    invalidPhone: 'Lütfen geçerli bir telefon numarası giriniz.',
    notAdmin: 'Yönetici değilsiniz. Lütfen WeWALK Sistem & Geliştirici Ekibi ile iletişime geçiniz.',
    invalidPhoneLength: 'Lütfen geçerli bir telefon numarası giriniz. Numara 10 karakter uzunluğunda olmalıdır.',
    invalidCountry: 'SMS gönderimi sadece Türkiye (+90) için mümkündür. Lütfen e-posta ile giriş yapmayı deneyin.',
    timeUpSecondsLeft: '{seconds} saniye kaldı.',
    resendCode: 'Kodu Yeniden Gönder',
    loginWithPhone: 'Telefon İle Giriş Yap',
    loginWithEmail: 'E-Posta İle Giriş Yap'
  },
  documentation: {
    documentation: 'Dokümantasyon',
    github: 'Github Deposu'
  },
  permission: {
    createRole: 'Yeni Rol',
    editPermission: 'Düzenle',
    roles: 'Rolleriniz',
    switchRoles: 'Rolleri Değiştir',
    tips: 'Bazı durumlarda, v-permission kullanmak işe yaramayabilir. Örneğin: Element-UI el-tab veya el-table-column ve dinamik olarak dom render eden diğer senaryolar. Bu durumda yalnızca v-if ile bunu yapabilirsiniz.',
    delete: 'Sil',
    confirm: 'Onayla',
    cancel: 'İptal'
  },
  guide: {
    description: 'Rehber sayfası, projeye ilk kez giren bazı kişiler için yararlıdır. Projede bulunan özelliklerin kısaca tanıtılabilir.',
    button: 'Rehberi Göster'
  },
  components: {
    documentation: 'Dokümantasyon',
    tinymceTips: 'Zengin metin yönetimi, yönetim arka ucu için temel bir özelliktir, ancak aynı zamanda birçok tuzak içerir.',
    stickyTips: 'Sayfa belirlenen pozisyona kaydırıldığında üstte yapışkan olur.',
    backToTopTips1: "Sayfa belirlenen pozisyona kaydırıldığında, sağ alt köşede 'Yukarı Çık' düğmesi görünür",
    backToTopTips2: 'Düğmenin stilini özelleştirebilirsiniz, göster/gizle, görünme yüksekliği, geri dönüş yüksekliği.',
    imageUploadTips: 'Vue@1 sürümünü kullandığım için, şu anda mockjs ile uyumlu değil, kendim modifiye ettim.'
  },
  table: {
    dynamicTips1: 'Sabit başlık, sıralama başlık sırasına göre',
    dynamicTips2: 'Sabit olmayan başlık, tıklama sırasına göre sıralama',
    dragTips1: 'Varsayılan sıra',
    dragTips2: 'Sürükledikten sonraki sıra',
    title: 'Başlık',
    importance: 'Önem',
    type: 'Tür',
    remark: 'Açıklama',
    search: 'Ara',
    add: 'Ekle',
    export: 'Dışa Aktar',
    reviewer: 'İnceleyen',
    id: 'ID',
    date: 'Tarih',
    author: 'Yazar',
    readings: 'Okunma',
    status: 'Durum',
    actions: 'İşlemler',
    edit: 'Düzenle',
    publish: 'Yayınla',
    draft: 'Taslak',
    delete: 'Sil',
    cancel: 'İptal',
    confirm: 'Onayla'
  },
  appleNotif: {
    introTitle: 'Apple bildirim mutabakatı',
    introBody: 'Apple, ucumuzun kabul etmediği bildirimleri tekrar dener; 200 aldığı bir bildirimi ise bir daha göndermez. Bu yüzden ucun cevap verip hiçbir şey işlemediği bir aralıkta gelen yenileme, iptal ve iadeler kalıcı olarak kaybolur. Bu ekran Apple’a ne gönderdiğini sorar, bizim kaydımızla karşılaştırır ve farkı yeniden işleyebilir.',
    lastHours: 'Son {h} saat',
    check: 'Kontrol et',
    replayMissing: 'Eksikleri yeniden işle ({n})',
    statSent: 'Apple’ın gönderdiği',
    statProcessed: 'İşlenmiş',
    statMissing: 'Eksik',
    statReplayed: 'Yeniden işlenen',
    colStatus: 'Durum',
    colNotification: 'Bildirim',
    colProduct: 'Ürün',
    colTransaction: 'İşlem no',
    colSentAt: 'Apple’ın gönderim zamanı',
    colFirstAttempt: 'İlk deneme',
    colReplay: 'Yeniden işleme',
    processed: 'İşlenmiş',
    missing: 'Eksik',
    emptyWindow: 'Bu aralıkta Apple hiç bildirim göndermemiş.',
    outcome_replayed: 'Yeniden işlendi',
    outcome_no_action_needed: 'İşlem gerekmiyor',
    outcome_handler_error: 'İşleme hatası',
    outcome_failed: 'Başarısız',
    replayedN: '{n} bildirim yeniden işlendi',
    missingN: '{n} bildirim işlenmemiş görünüyor',
    noneMissing: 'Eksik bildirim yok',
    replayConfirmTitle: 'Eksikleri yeniden işle',
    replayConfirmBody: '{n} bildirim, canlı bir teslimatla aynı yoldan yeniden işlenecek. Aynı bildirim iki kez uygulanmaz. Devam edilsin mi?',
    continue: 'Devam',
    cancel: 'Vazgeç',
    errorNotConfigured: 'Apple Store Server API bu ortamda tanımlı değil, bu yüzden Apple’a sorulamıyor. Sunucuda APPLE_STORE_SERVER_KEY_ID, ISSUER_ID ve KEY_PATH ayarlanmalı.',
    errorGeneric: 'Kontrol başarısız oldu'
  },
  mcp: {
    introTitle: 'LLM istemcilerine salt okunur erisim',
    introBody: 'MCP, Claude gibi yapay zeka istemcilerinin sistemimize soru sorabilmesini saglayan bir protokol. Burada olusturulan anahtarla bir kisi kendi Claude Code kurulumundan kullanici, baston, satin alma ve ozellik verilerini sorgulayabilir. Hicbir arac veri yazamaz, degistiremez veya silemez. Anahtar bir kisiye baglidir; o kisinin rolu ne kadarini gorebilecegini belirler - admin her seyi, egitmen yalnizca kendi ogrencilerini, diger roller hicbir sey.',
    settingsTitle: 'Ayarlar',
    piiLabel: 'Kisisel verileri acik gonder',
    piiNote: 'Bu, hicbir sey secilmemis anahtarlarin varsayilani. Kapaliyken e-posta, telefon ve isim maskeli doner (ornek: h***n@gmail.com). Tek bir kisiye acmak icin varsayilani degil, o kisinin anahtarini ayarlayin. Degisiklik aninda degil, en gec 60 saniye icinde etkili olur. Test ve canli icin ayri tutulur.',
    piiInherit: 'Varsayilani izle',
    piiForceOn: 'Bu anahtara acik',
    piiForceOff: 'Bu anahtara kapali',
    effectiveOn: 'su an acik',
    effectiveOff: 'su an maskeli',
    piiKeyNote: 'Bu anahtar icin ayri bir karar verebilirsiniz. Varsayilani izlemek cogu durumda dogru olan.',
    keyPiiConfirmBody: '{label} anahtari, paneldeki varsayilan kapali olsa bile kullanici e-postalarini, telefonlarini ve isimlerini duz metin gorecek. Isi bitince varsayilana dondurmeniz onerilir. Devam edilsin mi?',
    overrideTitle: 'Bazi anahtarlar varsayilani gecersiz kiliyor',
    overrideBody: '{on} anahtar kisisel verileri varsayilandan bagimsiz olarak goruyor, {off} anahtar ise kapali sabitlenmis. Yani yukaridaki ayarin kapali olmasi tek basina kimsenin kisisel veri goremedigi anlamina gelmiyor.',
    resetPii: 'Tum anahtarlari varsayilana dondur',
    resetPiiConfirmBody: 'Ayrica ayarlanmis butun anahtarlar yeniden paneldeki varsayilani izlemeye baslayacak. Devam edilsin mi?',
    resetPiiDone: '{n} anahtar varsayilana donduruldu',
    piiOn: 'Acik',
    piiOff: 'Kapali',
    piiConfirmTitle: 'Kisisel verileri ac',
    piiConfirmBody: 'Bu ayar acikken MCP anahtari olan herkes kullanici e-postalarini, telefonlarini ve isimlerini duz metin olarak gorebilir. Isiniz bitince kapatmaniz onerilir. Devam edilsin mi?',
    endpoint: 'MCP adresi:',
    keysTitle: 'Anahtarlar',
    newKey: 'Yeni anahtar',
    label: 'Etiket',
    labelPlaceholder: 'orn. Destek ekibi - Ayse',
    owner: 'Sahibi',
    ownerEmail: 'Kullanici e-postasi',
    ownerNote: 'Anahtarin baglanacagi WeWALK hesabi. Bu kisinin admin veya egitmen rolu olmali.',
    validFor: 'Gecerlilik',
    days: 'gun',
    status: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    expired: 'Suresi doldu',
    revoked: 'Iptal',
    expiresAt: 'Son kullanma',
    lastUsed: 'Son kullanim',
    calls: 'Cagri',
    actions: 'Islem',
    revoke: 'Iptal et',
    revokeConfirmTitle: 'Anahtari iptal et',
    revokeConfirmBody: '{label} anahtari calismaz hale gelecek. Bu islem geri alinamaz, yeni anahtar olusturmaniz gerekir. Devam edilsin mi?',
    create: 'Olustur',
    cancel: 'Vazgec',
    continue: 'Devam',
    done: 'Tamam',
    copy: 'Kopyala',
    copied: 'Kopyalandi',
    saved: 'Kaydedildi',
    failed: 'Islem basarisiz',
    fillAll: 'E-posta ve etiket zorunlu',
    keyReadyTitle: 'Anahtar hazir',
    keyOnceWarning: 'Bu anahtar bir daha gosterilmeyecek. Simdi kopyalayin.',
    howtoTitle: 'Claude Code icin kurulum komutu',
    callsTitle: 'Cagri kaydi',
    callsNote: 'Sunucuya gelen her istek burada. Reddedilen anahtar denemeleri de kayitli - bir sorun yasandiginda ilk bakilacak yer burasi. Sonuclar kaydedilmiyor, sadece ne soruldugu.',
    last7: 'Son 7 gun',
    rejected: 'Reddedildi',
    errors: 'Hata',
    withPii: 'Kisisel veri acikken',
    subject: 'Konu',
    subjectPlaceholder: 'E-posta, seri no veya arama terimi',
    onlyProblems: 'Sadece sorunlular',
    search: 'Ara',
    method: 'Metot',
    keyPrefix: 'Anahtar oneki',
    client: 'Istemci',
    userAgent: 'User agent',
    error: 'Hata',
    okShort: 'Tamam',
    unknownKey: 'Tanimsiz anahtar',
    unknownKeyNote: 'Sunulan anahtar hicbir kisiye cozulmedi: suresi dolmus, iptal edilmis, yanlis ortama ait veya hic var olmamis olabilir. Anahtar onekine bakarak hangisi oldugunu anlayabilirsiniz.',
    time: 'Zaman',
    tool: 'Arac',
    arguments: 'Parametreler',
    result: 'Sonuc',
    rows: 'satir',
    pii: 'PII',
    duration: 'Sure',
    refresh: 'Yenile'
  },
  placesCompare: {
    introTitle: 'Aynı sorgu, iki sağlayıcı, yan yana',
    introBody: 'Uygulamanın kullandığı sorgunun aynısı hem Google Places hem Geoapify ile çalıştırılır ve iki sonuç yan yana gösterilir. Bu ekran sadece okur; hangi sağlayıcının canlıda çalıştığını değiştirmez. Turuncu işaretli satırlar sadece o sağlayıcının bulduğu mekanlardır.',
    preset: 'Bölge',
    latitude: 'Enlem',
    longitude: 'Boylam',
    category: 'Kategori',
    query: 'Metin arama',
    queryPlaceholder: 'örn. eczane',
    radius: 'Yarıçap (m)',
    fresh: 'Önbelleği atla',
    run: 'Karşılaştır',
    hintCategory: 'Kategori sorgusu çalıştırılıyor. Metin arama yazarsanız kategori yerine arama karşılaştırılır.',
    hintSearch: 'Metin arama karşılaştırılıyor. Google metin araması, Geoapify adres/mekan tamamlama kullanır.',
    shared: 'Ortak',
    verdictNone: 'İki sağlayıcı ortak tek mekan bile döndürmedi. Sebep anlaşmazlık değil sıralama: Google öne çıkanları, Geoapify en yakınları veriyor. 20 sonuç sınırı aynı sokaktan iki farklı dilim kesiyor.',
    verdictSome: 'Ortak mekanlar var ama listeler büyük ölçüde farklı. Google öne çıkanları, Geoapify en yakınları sıralıyor.',
    count: 'Sonuç',
    nearest: 'En yakın',
    farthest: 'En uzak',
    onlyHere: 'Sadece burada',
    withPhone: 'Telefon',
    withWebsite: 'Web',
    withRating: 'Puan',
    phone: 'telefon',
    website: 'web',
    rating: 'puan',
    noRun: 'Henüz sorgu çalıştırılmadı',
    noResult: 'Sonuç yok',
    failed: 'Karşılaştırma başarısız',
    cat_all: 'Tümü',
    cat_food: 'Yeme içme',
    cat_shop: 'Mağaza',
    cat_pubs: 'Bar / gece',
    cat_art: 'Sanat / kültür',
    cat_college: 'Eğitim',
    cat_fitness: 'Spor / sağlık',
    cat_professional: 'Hizmet / ofis'
  },
  placesProvider: {
    introTitle: 'Bu ayar uygulamadaki tüm mekan verisini değiştirir',
    introBody: 'Seçtiğiniz servis, kullanıcının çevresindeki mekanları, aramaları ve mekan detaylarını sağlar. Değişiklik bir dakika içinde tüm kullanıcılara yansır, dağıtım gerekmez. Sağlayıcılar aynı veriyi vermiyor: aşağıdaki tabloda hangisinin neyi verebildiği yazıyor.',
    cardTitle: 'Mekan servisi',
    active: 'Şu an çalışan',
    fallback: 'Yedek (ayar okunamazsa)',
    save: 'Değiştir',
    refresh: 'Yenile',
    confirmTitle: 'Mekan servisini değiştir',
    confirmBody: 'Tüm kullanıcılar için mekan verisi {name} servisinden gelmeye başlayacak. Sorun görürseniz aynı ekrandan geri alabilirsiniz. Devam edilsin mi?',
    continue: 'Devam',
    cancel: 'Vazgeç',
    saved: 'Değiştirildi',
    failed: 'İşlem başarısız',
    note_googleplaces: 'En zengin veri. Puan, yorum, fotoğraf ve işletme bilgilerini içerir.',
    note_geoapify: 'OpenStreetMap tabanlı. Konum ve temel bilgiler var; puan, yorum ve fotoğraf yok.',
    note_foursquare: 'Eski sağlayıcı. Şu an kullanılmıyor.',
    fieldsTitle: 'Sağlayıcılar neyi verebiliyor',
    fieldsBody: 'Geoapify OpenStreetMap verisini kullanıyor. Veremediği alanlar boş (null) döner; sıfır olarak değil. Böylece uygulama o satırı gizleyebilir, yanlış bir değer göstermez.',
    field: 'Alan'
  },
  pendingGrants: {
    introTitle: 'Bekleyen özellik tanımları',
    introBody: 'Satışta söz verilen özellikler, alıcı henüz kayıtlı değilse burada bekler. Kişi kaydolduğunda, giriş yaptığında ya da e-postasını düzelttiğinde otomatik olarak devredilir. Devredilmeyen kayıtlar genelde tek bir sebepten kalır: alıcı, satışta yazılandan farklı bir e-posta ile kaydolmuştur. O durumda buradan elle atamanız gerekir.',
    email: 'E-posta',
    feature: 'Özellik',
    source: 'Kaynak',
    status: 'Durum',
    waiting: 'Bekleme',
    actions: 'İşlem',
    statusAll: 'Tümü',
    status_pending: 'Bekliyor',
    status_claimed: 'Devredildi',
    status_cancelled: 'İptal',
    searchPlaceholder: 'E-posta ara',
    sweep: 'Tara',
    addManual: 'Elle tanım ekle',
    importFromCrm: 'CRM üzerinden içe aktar',
    staleTitle: '{n} tanım {days} günden uzun süredir sahipsiz',
    staleBody: 'Bu kişiler muhtemelen farklı bir e-posta ile kaydolmuş. Kendilerine ulaşıp doğru adresi öğrenin ya da hesabı bulup elle atayın.',
    nDays: '{n} gün',
    assign: 'Elle ata',
    cancel: 'İptal et',
    revoke: 'Geri al',
    assignTitle: 'Tanımı bir hesaba ata',
    assignBody: '{email} adresine söz verilen {feature} özelliği, seçtiğiniz hesaba devredilecek.',
    userSearchPlaceholder: 'E-posta veya isim ile ara (en az 2 karakter)',
    assigned: 'Devredildi',
    close: 'Kapat',
    save: 'Kaydet',
    continue: 'Devam',
    confirmTitle: 'Onay',
    saved: 'Kaydedildi',
    cancelled: 'İptal edildi',
    failed: 'İşlem başarısız',
    durationType: 'Süre tipi',
    durationValue: 'Süre',
    years: 'yıl',
    months: 'ay',
    days: 'gün',
    permanent: 'Süresiz',
    durationNote: 'Süre, özellik devredildiği anda başlar; satış tarihinden değil. Altı ay sonra kaydolan kişi tam bir yıl kullanır.',
    notes: 'Not',
    emailRequired: 'E-posta zorunlu',
    emailInvalid: 'Geçerli bir e-posta girin',
    featureRequired: 'Özellik seçin',
    cancelConfirm: '{feature} tanımı iptal edilecek. Henüz devredilmediği için geri alınacak bir hak yok. Devam edilsin mi?',
    revokeConfirm: '{feature} özelliği kullanıcıdan GERİ ALINACAK. Devam edilsin mi?',
    sweepDone: '{checked} adres kontrol edildi, {claimed} tanım devredildi',
    importTitle: 'CRM üzerinden içe aktar',
    sourceContacts: 'Kişiler',
    sourceDeals: 'Satışlar (Deal)',
    contactsNote: 'Kişideki "WeWALK: features to grant" alanı okunur. Bu alan her saat başı otomatik olarak da içe aktarılıyor, buradan beklemeden çalıştırabilirsiniz.',
    dealsNote: 'Deal kaydına eklenen ürün satırları okunur. Çoğu deal kaydında ürün satırı olmadığı için genelde Kişiler kullanılmalı.',
    emailsPlaceholder: 'Ya da e-posta (virgülle)',
    typed: 'Alana yazılan',
    unknownTokens: 'Okunamadı: {tokens}',
    contactImportSummary: '{contactsSeen} kişi incelendi, {grantsCreated} tanım oluştu, {claimedImmediately} tanesi hemen devredildi, {unreadable} kişide okunamayan değer var, {withoutEmail} kişide e-posta yok',
    outcome_no_email: 'E-posta yok',
    outcome_empty: 'Alan boş',
    outcome_no_recognised_features: 'Okunamadı',
    importWarnTitle: 'Önce kuru çalıştırın',
    importWarnBody: 'Kuru çalıştırma hiçbir şey yazmaz, sadece ne olacağını gösterir. Sonucu inceleyip doğru bulduğunuzda uygulayın. Geniş bir pencereyle çalıştırmak geçmiş satışlardan toplu tanım üretebilir.',
    lastHours: 'Son {h} saat',
    dealIdsPlaceholder: 'Ya da deal no (virgülle)',
    dryRun: 'Kuru çalıştır',
    apply: 'Uygula',
    applyConfirm: 'Listede görünen satışlar için bekleyen tanımlar oluşturulacak. Aynı satış iki kez tanım üretmez. Devam edilsin mi?',
    importApplied: '{n} tanım oluşturuldu',
    importSummary: '{dealsSeen} satış incelendi, {grantsCreated} tanım oluştu, {claimedImmediately} tanesi hemen devredildi, {withoutContactEmail} satışta e-posta yok, {withoutFeatures} satışta özellik taşıyan ürün yok',
    deal: 'Satış',
    outcome: 'Sonuç',
    outcome_created: 'Oluşturuldu',
    outcome_would_create: 'Oluşturulacak',
    outcome_no_line_items: 'Ürün satırı yok',
    outcome_no_features_on_skus: 'Özellik taşımıyor',
    outcome_no_contact_email: 'E-posta yok',
    empty: 'Kayıt bulunamadı'
  },
  adminUsers: {
    tabSingle: 'Tek kullanıcı',
    tabBulk: 'Excel ile toplu',
    bulkStep1: '1. Şablonu indirin',
    downloadTemplate: 'Şablonu indir',
    bulkColumnsHint: 'Sütun başlıklarını değiştirmeyin. Başlıklar her iki dilde de aynıdır; büyük/küçük harf farkı sorun değildir.',
    colColumn: 'Sütun',
    colRequired: 'Durum',
    colMeaning: 'Açıklama',
    required: 'Zorunlu',
    docEmail: 'Kişinin WeWalk uygulamasına kaydolacağı e-posta adresi',
    docFirstName: 'Ad. Bilinmiyorsa adresten tahmin edin, sonradan düzeltilebilir',
    docLastName: 'Soyad',
    docCountryCode: 'Ülke kodu, sadece rakam (örn. 49). Telefon yazacaksanız zorunlu',
    docPhoneNumber: 'Telefon, sadece rakam. Boş bırakın; uydurma numara yazmayın',
    bulkStep2: '2. Doldurduğunuz dosyayı yükleyin',
    bulkStep3: '3. Kontrol edin ve oluşturun',
    bulkSummary: '{ready} satır hazır, {invalid} satır hatalı',
    invalidSkipped: 'Hatalı satırlar atlanacak, diğerleri oluşturulacak. Hatalı satırları düzeltip dosyayı tekrar yükleyebilirsiniz.',
    rowNo: 'Satır',
    status: 'Durum',
    status_ready: 'Hazır',
    status_invalid: 'Hatalı',
    status_creating: 'Oluşturuluyor',
    status_created: 'Oluşturuldu',
    status_failed: 'Başarısız',
    createN: '{n} kullanıcıyı oluştur',
    downloadResults: 'Sonuçları indir',
    bulkConfirmTitle: 'Toplu oluşturma',
    bulkConfirmBody: '{n} kullanıcı oluşturulacak. Her birinin adresi sistemde kayıtlı sayılacak ve bu kişilerin Kayıt Ol değil Giriş Yap demesi gerekecek. Devam edilsin mi?',
    continue: 'Devam',
    cancel: 'Vazgeç',
    fileLoaded: '{n} satır okundu',
    fileEmpty: 'Dosyada satır bulunamadı',
    fileTooLarge: 'Dosya boyutu 5 MB üzerinde olamaz',
    tooManyRows: 'Tek seferde en fazla {max} satır yükleyebilirsiniz',
    duplicateInFile: 'Bu e-posta dosyada birden fazla kez geçiyor',
    bulkDone: '{ok} kullanıcı oluşturuldu',
    bulkDoneWithErrors: '{ok} kullanıcı oluşturuldu, {failed} satır başarısız',
    introTitle: 'Kullanıcıyı siz açtığınızda ne oluyor',
    introBody: 'Hesap açıldığı anda o e-posta adresi sistemde kayıtlı sayılır. Kişi uygulamada <b>Kayıt Ol</b> derse "bu e-posta kayıtlı" hatası alır, <b>Giriş Yap</b> demesi gerekir. Girişte kod yine kendi posta kutusuna gider, yani buradan açtığınız hesaba sizin de kimsenin de erişimi olmaz. Hesabı açtığınız kişiye giriş yapması gerektiğini mutlaka iletin.',
    newUser: 'Yeni kullanıcı',
    email: 'E-posta',
    emailPlaceholder: 'ornek@site.com',
    firstName: 'Ad',
    lastName: 'Soyad',
    fullName: 'Ad Soyad',
    countryCode: 'Ülke kodu',
    countryCodePlaceholder: '49',
    phone: 'Telefon',
    optional: 'isteğe bağlı',
    phoneHint: 'Telefon zorunlu değil, boş bırakabilirsiniz. Uydurma numara yazmayın: o numara bir gün gerçek bir kişiye ait olursa, o kişi kaydolamaz.',
    create: 'Kullanıcıyı oluştur',
    clear: 'Temizle',
    createdThisSession: 'Bu oturumda açılanlar',
    noneYet: 'Henüz kullanıcı açmadınız.',
    userId: 'Kullanıcı no',
    createdMessage: '{email} oluşturuldu',
    emailRequired: 'E-posta zorunlu',
    emailInvalid: 'Geçerli bir e-posta girin',
    firstNameRequired: 'Ad zorunlu',
    phonePairRequired: 'Ülke kodu ve telefon birlikte doldurulmalı, ya ikisi de dolu ya ikisi de boş',
    errorEmailTaken: 'Bu e-posta zaten kayıtlı. Kişi Giriş Yap ile devam etmeli.',
    errorPhoneTaken: 'Bu telefon numarası başka bir hesapta kayıtlı.',
    errorEmailInvalid: 'E-posta adresi geçersiz.',
    errorFirstNameRequired: 'Ad alanı zorunlu.',
    errorPhoneIncomplete: 'Ülke kodu ve telefon birlikte doldurulmalı.',
    errorGeneric: 'Kullanıcı oluşturulamadı'
  },
  savedPlaces: {
    tab: 'Kayıtlı Yerler',
    refresh: 'Yenile',
    addNew: 'Yeni Yer Ekle',
    editPlace: 'Yeri Düzenle',
    title: 'Başlık',
    address: 'Adres',
    latitude: 'Enlem',
    longitude: 'Boylam',
    type: 'Tür',
    actions: 'İşlem',
    empty: 'Kayıtlı yer bulunamadı',
    typeMyLocation: 'Konumum (mylocation)',
    typeExploration: 'Keşif (exploration)',
    typeStation: 'Durak (station)',
    editNote: 'Not: Koordinat ve tür yalnızca yeni yer eklerken ayarlanır; düzenlemede başlık ve adres güncellenir.',
    coordsRequired: 'Enlem ve boylam zorunludur',
    saved: 'Kaydedildi',
    saveFailed: 'Kaydedilemedi',
    deleteConfirm: 'Bu kayıtlı yer silinsin mi?',
    confirmTitle: 'Onay',
    deleted: 'Silindi',
    deleteFailed: 'Silinemedi',
    fetchFailed: 'Kayıtlı yerler alınamadı',
    save: 'Kaydet',
    cancel: 'İptal',
    titlePlaceholder: 'Ev, İş, ...'
  },
  savedRoutes: {
    create: 'Yeni Rota',
    createTitle: 'Yeni Rota Oluştur',
    forUser: 'Kullanıcı',
    userSearchPlaceholder: 'E-posta veya isim ile ara (en az 2 karakter)',
    userRequired: 'Kullanıcı seçilmeli',
    titleRequired: 'Başlık zorunlu',
    points: 'Başlangıç ve Varış',
    clickToPlace: 'Haritaya tıklayarak yerleştirin veya işaretçiyi sürükleyin:',
    address: 'Adres',
    latitude: 'Enlem',
    longitude: 'Boylam',
    coordInvalid: 'Geçerli bir koordinat girin',
    tab: 'Rotalar',
    pageTitle: 'Kayıtlı Rotalar',
    refresh: 'Yenile',
    title: 'Başlık',
    user: 'Kullanıcı',
    visibility: 'Görünürlük',
    visibilityPrivate: 'Özel',
    visibilityPublic: 'Herkese Açık',
    start: 'Başlangıç',
    end: 'Varış',
    distance: 'Mesafe',
    duration: 'Süre',
    trackPoints: 'İz Noktası',
    source: 'Kaynak',
    date: 'Tarih',
    actions: 'İşlem',
    empty: 'Kayıtlı rota bulunamadı',
    detailTitle: 'Rota Detayı',
    description: 'Açıklama',
    waypoints: 'Ara Noktalar',
    makePublic: 'Herkese Aç',
    makePrivate: 'Özel Yap',
    visibilityUpdated: 'Görünürlük güncellendi',
    visibilityUpdateFailed: 'Görünürlük güncellenemedi',
    deleteConfirm: 'Bu rota silinsin mi?',
    confirmTitle: 'Onay',
    deleted: 'Silindi',
    deleteFailed: 'Silinemedi',
    fetchFailed: 'Rotalar alınamadı',
    saved: 'Kaydedildi',
    saveFailed: 'Kaydedilemedi',
    save: 'Kaydet',
    cancel: 'İptal',
    close: 'Kapat',
    edit: 'Düzenle',
    editTitle: 'Rotayı Düzenle',
    searchPlaceholder: 'Başlık veya kullanıcı emaili',
    all: 'Tümü'
  },
  example: {
    warning: "Yaratma ve düzenleme sayfaları keep-alive tarafından önbelleğe alınamaz, çünkü keep-alive'ın 'include' özelliği şu anda rotalara göre önbelleğe alma desteklemiyor."
  },
  errorLog: {
    tips: 'Lütfen sağ üst köşedeki hata ikonuna tıklayın',
    description: 'Şimdi yönetim sistemi temel olarak spa formunda, bu kullanıcı deneyimini artırır, ama aynı zamanda sayfa problemlerinin olasılığını da artırır.',
    documentation: 'Dokümantasyon tanıtımı'
  },
  excel: {
    export: 'Dışa Aktar',
    selectedExport: 'Seçilenleri Dışa Aktar',
    placeholder: 'Lütfen dosya adını girin (varsayılan excel-listesi)'
  },
  zip: {
    export: 'Dışa Aktar',
    placeholder: 'Lütfen dosya adını girin (varsayılan dosya)'
  },
  pdf: {
    tips: 'PDF indirme özelliğini gerçekleştirmek için burada window.print() kullanıyoruz.'
  },
  theme: {
    change: 'Temayı Değiştir',
    documentation: 'Tema Dokümantasyonu',
    tips: 'İpuçları: Navbar üzerindeki tema seçimi ile iki farklı derleme yöntemidir, her biri farklı uygulama senaryoları için geçerlidir.'
  },
  tagsView: {
    refresh: 'Yenile',
    close: 'Kapat',
    closeOthers: 'Diğerlerini Kapat',
    closeAll: 'Tümünü Kapat'
  },
  settings: {
    title: 'Sayfa Stili Ayarı',
    theme: 'Tema Rengi',
    showTagsView: 'Etiket Görünümünü Aç',
    showSidebarLogo: 'Kenar Çubuğu Logosunu Göster',
    fixedHeader: 'Sabit Başlık',
    sidebarTextTheme: 'Kenar Çubuğu Metin Teması'
  },
  columnType: {
    firstName: 'Adı',
    lastName: 'Soyadı',
    email: 'E-posta',
    countryCode: 'Ülke Telefon Kodu',
    country: 'Ülke Adı',
    city: 'Şehir Adı',
    userType: 'Kullanıcı Tipi',
    caneId: 'Baston ID',
    minutes: 'Dakika',
    assistant: 'Asistan',
    phoneNumber: 'Telefon Numarası',
    assistantRegion: 'Asistan Bölgesi',
    isPremium: 'Premium Mu'
  },
  package: {
    yearly: 'Yıllık',
    monthly: 'Aylık',
    'monthly-consult': 'Danış - Aylık',
    additional: 'Ek Paket',
    'additional-consult': 'Danış - Ek',
    minutes: 'dakika',
    general: 'Genel',
    android: 'Android',
    ios: 'iOS',
    code: 'Paket Kodu',
    name: 'Paket Adı',
    platform: 'Platform',
    type: 'Tip',
    balance: 'Bakiye',
    order: 'Sıra',
    state: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    edit: 'Düzenle',
    description: 'Açıklama',
    buttonText: 'Buton Metni',
    addNewPackage: 'Yeni Paket Ekle',
    isFirstSubscription: 'İlk Abonelik için Hediye',
    title: 'Başlık',
    testPackage: 'Görünürlük',
    isTest: 'Test Paketi',
    isTestHint: 'Sadece belirtilen test kullanıcılarına görünür',
    testUsers: 'Test Kullanıcıları',
    testUsersPlaceholder: 'E-posta adreslerini virgülle ayırarak girin (örn: kullanici1@email.com, kullanici2@email.com)'
  },
  freeZone: {
    addNewSponsor: 'Yeni Sponsor Ekle',
    name: 'Adı',
    company: 'Şirket',
    latitude: 'Enlem',
    longitude: 'Boylam',
    range: 'Menzi',
    isCity: 'Şehir Mi?',
    state: 'Durum',
    active: 'Aktif',
    yes: 'Evet',
    no: 'Hayır',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    deletePopup: 'Bu sponsoru silmek istediğinizden emin misiniz?',
    cancel: 'İptal',
    ok: 'Tamam',
    dataNotAvailable: 'Veri Mevcut Değil'
  },
  assistantConfig: {
    addNewAssistantConfig: 'Yeni Asistan Ayarı Ekle',
    region: 'Bölge',
    workingHoursStart: 'Çalışma Saati Başlangıcı',
    workingHoursEnd: 'Çalışma Saati Bitişi',
    workingHours: 'Çalışma Saatleri',
    workingDays: 'Çalışma Günleri',
    state: 'Durum',
    active: 'Aktif',
    yes: 'Evet',
    no: 'Hayır',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    deletePopup: 'Bu asistan ayarını silmek istediğinizden emin misiniz?',
    cancel: 'İptal',
    ok: 'Tamam',
    timezone: 'Saat Dilimi',
    dataNotAvailable: 'Veri Mevcut Değil'
  },
  company: {
    addNewCompany: 'Yeni Şirket Ekle',
    header: 'Başlık',
    name: 'Adı',
    description: 'Açıklama',
    link: 'Bağlantı',
    order: 'Sıra',
    state: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    deletePopup: 'Bu şirketi silmek istediğinizden emin misiniz?',
    cancel: 'İptal',
    ok: 'Tamam',
    dataNotAvailable: 'Veri Mevcut Değil',
    region: 'Bölge'
  },
  subject: {
    addNewSubject: 'Yeni Konu Ekle',
    name: 'Konu Adı',
    state: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    cancel: 'İptal',
    ok: 'Tamam',
    dataNotAvailable: 'Veri Mevcut Değil',
    region: 'Bölge'
  },
  brand: {
    addNewBrand: 'Yeni Marka Ekle',
    name: 'Marka Adı',
    state: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    cancel: 'İptal',
    ok: 'Tamam',
    dataNotAvailable: 'Veri Mevcut Değil',
    region: 'Bölge'
  },
  brandSubject: {
    addNewBrandSubject: 'Yeni Marka Konusu Ekle',
    consultSubjectName: 'Danışma Konu Adı',
    consultBrandName: 'Danışma Marka Adı',
    orderNo: 'Sıra No',
    isConsultFree: 'Danışma Ücretsiz Mi?',
    free: 'Ücretsiz',
    paid: 'Ücretli',
    state: 'Durum',
    active: 'Aktif',
    passive: 'Pasif',
    edit: 'Düzenle',
    delete: 'Sil',
    actions: 'Eylemler',
    cancel: 'İptal',
    ok: 'Tamam',
    dataNotAvailable: 'Veri Mevcut Değil',
    region: 'Bölge',
    regionPlaceholder: 'Bir veya daha fazla ülke seçin',
    regionHint: 'Tüm ülkelerde geçerli olması için boş bırakın.',
    allCountries: 'Tüm ülkeler'
  },
  localization: {
    addNewLocalization: 'Yeni Yerelleştirme Ekle',
    import: 'İçe Aktar',
    export: 'Dışa Aktar',
    search: 'Ara',
    save: 'Kaydet',
    updateVersion: 'Sürümü Güncelle',
    delete: 'Sil',
    confirmDeleteMessage: 'Bu satırı silmek istediğinize emin misiniz?',
    warning: 'Uyarı',
    yes: 'Evet',
    no: 'Hayır',
    success: 'Başarılı',
    error: 'Hata',
    rowDeleted: 'Satır başarıyla silindi!',
    deleteFailed: 'Satır silinemedi.',
    versionUpdated: 'Sürüm başarıyla güncellendi!',
    emailSent: 'Yerelleştirme anahtarları başarıyla şu adrese gönderildi',
    rowUpdated: 'Satır başarıyla güncellendi!',
    updateFailed: 'Satır güncellenemedi.',
    fileImported: 'Dosya başarıyla içe aktarıldı!',
    importFailed: 'Dosya içe aktarılamadı.',
    loading: 'Yükleniyor...',
    iosKey: 'IOS Anahtarı',
    androidKey: 'Android Anahtarı',
    enterIosKey: 'IOS Anahtarını Girin',
    enterAndroidKey: 'Android Anahtarını Girin',
    enterLanguage: 'Dil Girin',
    enterValue: 'Değer Girin',
    enterKey: 'Anahtar Girin',
    languageKey: 'Dil',
    value: 'Değer',
    key: 'Anahtar',
    actions: 'İşlemler',
    importInProgress: 'Ice aktarma devam ediyor...',
    confirmUpdateVersionMessage: 'Yerellestirme surumunu guncellemek istediginize emin misiniz?',
    fileRequired: 'Lutfen ice aktarmadan once bir dosya secin.',
    confirmImportMessage: 'Secilen dosyayi ice aktarmak istediginize emin misiniz?',
    noErrorsFound: 'Herhangi bir hata bulunamadi.',
    unknownError: 'Bilinmeyen bir hata olustu.'
  },
  rules: {
    totalEvaluations: 'Toplam Degerlendirme',
    matchRate: 'Eslesme Orani',
    featuresGranted: 'Tanimlanan Ozellikler',
    errors: 'Hatalar',
    avgDuration: 'Ort. Sure',
    executionHistory: 'Calistirma Gecmisi',
    date: 'Tarih',
    ruleName: 'Kural Adi',
    triggerType: 'Tetikleyici Tipi',
    matched: 'Eslesti',
    user: 'Kullanici',
    duration: 'Sure',
    conditionsContext: 'Kosul Verisi',
    grantedFeatures: 'Tanimlanan Ozellikler',
    errorMessage: 'Hata Mesaji',
    filterByRule: 'Kurala Gore Filtrele',
    filterByMatch: 'Eslesme Durumu',
    allRules: 'Tum Kurallar',
    matchedOnly: 'Eslesen',
    unmatchedOnly: 'Eslesmeyen',
    noData: 'Calistirma verisi bulunamadi',
    last30Days: 'Son 30 Gun',
    last7Days: 'Son 7 Gun',
    last90Days: 'Son 90 Gun',
    sourceReference: 'Kaynak Referansi'
  },
  otaFiles: {
    pinOnly: 'Pinlemeye Özel',
    pinOnlyCreateHint: "İşaretlendiğinde bu OTA genele dağıtılmaz — sadece kullanıcıya manuel pin'lendiğinde inebilir. Edit'le sonradan açılabilir.",
    pinOnlyEditHint: 'Kapatırsanız bu OTA genele açılır.',
    overridesOlderPins: 'Eski Pinleri Geçersiz Kıl',
    overridesOlderPinsHint: 'Açıldığında bu sürüm AYNI major\'daki mevcut pinleri geçersiz kılar (örn. 2.46.0, 2.44.0/2.45.0 pinlerini geçersiz kılar) — pinli kullanıcılar bir sonraki OTA isteğinde normal rollout\'a düşer. Cross-major güvenli (V3 sürümü V2 pinlerini etkilemez).'
  },
  userDialog: {
    consultGranted: 'Verilen: {min} dk ({sec}s)',
    consultUsed: 'Tüketilen: {min} dk ({sec}s)',
    consultRemaining: 'Kalan: {min} dk ({sec}s)',
    callDate: 'Çağrı Tarihi',
    callDuration: 'Çağrı Süresi',
    deductedFromPackage: 'Bu Paketten Düşen',
    minShort: 'dk',
    overflow: 'taşma',
    noConsultDeductions: 'Bu paketten dakika tüketen kayıtlı çağrı yok (bu özellik devreye girmeden önce yapılan çağrılar burada görünmez).',
    remaining: 'Kalan',
    used: 'Tüketilen',
    devicesTab: 'Cihazlar ve OTA',
    noActiveDevice: 'Kullanıcının ACTIVE cihazı yok.',
    installed: 'Yüklü:',
    previousVersion: '(önceki: {version})',
    lastDownloadedOta: 'Son indirilen OTA:',
    legacyLog: 'eski log (cihaz yok)',
    noData: 'veri yok',
    deleteAccount: 'Hesabı Sil',
    loadDevicePinFailed: 'Cihaz/pin bilgisi alınamadı: {msg}',
    deletionPreviewFailed: 'Silme önizlemesi alınamadı: {msg}',
    purgeConfirm: '{target} hesabı kalıcı olarak silinecek: {rows} kayıt silinir, {devices} bastonun bağı kaldırılır. Bu işlem geri alınamaz. Onaylamak için {field} yazın.',
    purgeFieldEmail: 'e-posta adresini',
    purgeFieldUserId: 'kullanıcı ID değerini',
    deletePermanently: 'Kalıcı olarak sil',
    valueMismatch: 'Değer eşleşmiyor',
    accountDeleted: 'Hesap silindi',
    deleteAccountFailed: 'Hesap silinemedi: {msg}',
    justNow: 'az önce',
    minutesAgo: '{n} dk önce',
    hoursAgo: '{n} sa önce',
    daysAgo: '{n} gün önce | {n} gün önce'
  },
  failedActivations: {
    searchTab: 'Arama',
    tabLabel: 'Sorunlu Aktivasyonlar',
    description: 'Aktivasyon tamamlandı görünüyor ama baston kullanıcıya bağlı değil. Bu durumda bastonun kalıcı özellikleri (Smart Map, Voice Assistant, Smart Cane Basic) kullanıcıya hiç geçmez.',
    searchPlaceholder: 'E-posta, ad, soyad veya baston seri no',
    search: 'Ara',
    refresh: 'Yenile',
    firstName: 'Ad',
    lastName: 'Soyad',
    email: 'E-posta',
    caneSerial: 'Baston Seri No',
    type: 'Tip',
    issue: 'Sorun',
    noDeviceRecord: 'Cihaz kaydı yok',
    unowned: 'Sahipsiz',
    boundToAnotherUser: 'Başkasına bağlı',
    deviceOwner: 'Cihazın Sahibi',
    lostPermanentFeatures: 'Kaybolan Kalıcı Özellik',
    featureCount: '{n} özellik | {n} özellik',
    activation: 'Aktivasyon',
    action: 'İşlem',
    brokenSerialTooltip: 'Bozuk seri: baston gerçek seri numarasını okutamıyor. Etiketteki gerçek seriyi Cihazlar ekranında arayıp Connect ile bağlayın.',
    brokenSerial: 'Bozuk seri',
    bindAndGrant: 'Bağla ve Özellikleri Tanımla',
    empty: 'Sorunlu aktivasyon yok',
    bindConfirm: '{serial} bastonu {email} hesabına bağlanacak ve bastonun özellikleri bu kullanıcıya tanımlanacak. Devam edilsin mi?',
    bindTitle: 'Bastonu bağla',
    bind: 'Bağla',
    cancel: 'Vazgeç',
    bindSuccess: 'Baston bağlandı, özellikler tanımlandı',
    bindFailed: 'Bağlama başarısız',
    loadFailed: 'Sorunlu aktivasyonlar alınamadı'
  },
  devicesScreen: {
    zohoCheckedUpTo: 'Zoho paket listesinin {page}. sayfasına kadar bakıldı. Bulunamayan seriler sonraki sayfalarda olabilir.',
    scanNextZohoPage: 'Sonraki Zoho sayfasını tara ({page})',
    managePins: 'Pin Yönet',
    managePinsFor: 'Pin Yönet - {serial}',
    deviceNotBound: 'Cihaz bir kullanıcıya bağlı değil - pin yapılamıyor.',
    user: 'Kullanıcı:',
    installed: 'Yüklü:',
    pinsOnDevice: 'Bu cihazdaki pinler',
    applyUpdatePin: 'Pin uygula / güncelle',
    loadPinInfoFailed: 'Pin bilgisi alınamadı: {msg}',
    loadDevicePinInfoFailed: 'Cihaz pin bilgisi alınamadı: {msg}',
    syncConfirm: 'Özelliği eksik bastonlar Zoho paketlerinde aranacak (Zoho sayfa {page}, yaklaşık 200 Zoho API çağrısı, birkaç dakika sürebilir). Bu adım sadece önizleme yapar, uygulama ayrıca onay ister. Devam edilsin mi?',
    startScan: 'Taramayı başlat'
  },
  otaPin: {
    allCanes: 'Tüm bastonlar (user-scope)',
    allCanesScope: 'tüm bastonlar (user-scope)',
    delete: 'Sil',
    noPins: 'pin yok',
    today: 'bugün',
    yesterday: 'dün',
    daysAgo: '{n} gün önce',
    weeksAgo: '{n} hafta önce',
    monthsAgo: '{n} ay önce',
    pinForAllUserCanes: 'Kullanıcının tüm bastonları için pinle',
    userScopeHint: '(Pin device_serial_number=NULL ile kaydedilir; mobil deviceSerial göndermese de uygulanır, V2/V3 ayrımı sunucuda korunur)',
    device: 'Cihaz:',
    selectDevice: 'Cihaz seç',
    lastConnected: 'son bağlanılan',
    noActiveDevice: 'Aktif cihaz yok - pin atılamaz',
    locked: 'sabit',
    allCanesHint: 'Tüm bastonlar kapsamında pin. Seçilen OTA\'nın major sürümüne uyan cihaz(lar) bu pini alır, diğerleri rollout\'ta kalır.',
    version: 'Versiyon:',
    onlyMajorPinnable: '→ sadece {range} OTA\'lar pinlenebilir.',
    alreadyPinned: 'Bu cihaza zaten pinli: {version}',
    cannotPin: 'Pinleme yapılamıyor.',
    serialFormatMismatch: 'Seçili cihazın seri numarası ({serial}) standart {format} formatına uymuyor.',
    selectOtaVersion: 'OTA versiyonu seç',
    reasonPlaceholder: 'Sebep (opsiyonel - örn. \'crash repro\')',
    updatePin: 'Pin\'i güncelle',
    pin: 'Pin\'le',
    pinUpdated: 'Pin güncellendi',
    pinApplied: 'Pin uygulandı',
    applyFailed: 'Pin uygulanamadı: {msg}',
    applyFailedCode: 'Pin uygulanamadı ({code})',
    unknownError: 'bilinmeyen hata',
    removeConfirm: '{version} pin\'i ({scope}) kaldırılacak. Onaylıyor musun?',
    removeTitle: 'Pin Kaldırma',
    removeConfirmButton: 'Evet, kaldır',
    removed: 'Pin kaldırıldı',
    removeFailed: 'Pin kaldırılamadı: {msg}'
  },
  bulkGrantCleanup: {
    statActiveUsers: 'Aktif bulk grant\'lı kullanıcı',
    statDistinctBatches: 'Farklı bulk grant batch',
    statRevokedUsers: 'Bulk grant kaldırılmış kullanıcı',
    statVerified: 'Doğrulanmış',
    tabPending: 'Aktif Bulk Grant\'lar',
    tabRemoved: 'Kaldırılan Bulk Grant\'lar',
    byFeature: 'Feature dağılımı:',
    clearFilter: 'Filtreyi temizle',
    deviceType: 'Cihaz Türü',
    countryPlaceholder: 'Ülke (TR/US/...)',
    searchPlaceholder: 'Ara: email / isim / telefon / seri no',
    filter: 'Filtrele',
    reset: 'Sıfırla',
    selected: 'seçili',
    clearSelection: 'Seçimi Temizle',
    removeBulkGrants: 'Bulk Grant\'ları Kaldır',
    removeAllMatching: 'Filtreye Uyan Tümünü Kaldır',
    markReviewed: 'İncelendi Olarak İşaretle',
    restore: 'Geri Yükle',
    colDevice: 'Cihaz',
    noDevice: 'cihazsız',
    serialFormatWarning: 'Seri numarası standart WW-OZ-XXXXN-XXXXXX formatına uymuyor - V2/V3 belirlenemediği için pinleme yapılamaz.',
    notPinnable: 'pinlenemez',
    colUser: 'Kullanıcı',
    colCountry: 'Ülke',
    colBulkFeatures: 'Bulk / Campaign Feature\'lar',
    noExpiry: 'Süresiz',
    alternativeSources: 'Alternatif kaynaklar:',
    colCleanupStatus: 'İşlem Durumu',
    otaInstalled: 'yüklü:',
    otaPrevious: 'önceki:',
    otaLastDownloaded: 'son indirilen:',
    noData: 'veri yok',
    colActions: 'İşlem',
    details: 'Detay',
    detailTitleFor: '{name} - Detay',
    userActivity: 'Kullanıcı Aktivitesi',
    lastLogin: 'Son giriş',
    lastConsultCall: 'Son consult çağrısı',
    never: 'Hiç',
    consultCalls30d: 'Son 30g consult çağrı',
    consultMinutes30d: 'Son 30g consult dakika',
    minutesShort: '{n} dk',
    devices: 'Cihazlar',
    serialNo: 'Seri No',
    type: 'Tür',
    status: 'Durum',
    activation: 'Aktivasyon',
    noActiveDevices: 'Bu kullanıcının aktif cihazı yok.',
    allEntitlements: 'Tüm Entitlement\'lar',
    rowCount: '{n} satır',
    source: 'Kaynak',
    start: 'Başlangıç',
    end: 'Bitiş',
    active: 'Aktif',
    revoked: 'İptal',
    inactive: 'Pasif',
    otaVersion: 'OTA Versiyonu',
    installedApp: 'Şu an cihazda yüklü (app)',
    installedWireless: 'Şu an cihazda yüklü (wireless)',
    previousApp: 'Önceki yüklü (app)',
    previousWireless: 'Önceki yüklü (wireless)',
    appReportedVersion: 'App\'in raporladığı sürüm (heartbeat)',
    lastDownloadedOta: 'Son indirdiği OTA',
    manualPin: 'Manuel Pin (Override)',
    activePins: '{n} aktif pin',
    noPin: 'pin yok - normal rollout',
    otaHelp: 'Pin atılmamış kullanıcılar normal rollout/canary akışından gider. Pin atıldığında bu kullanıcı seçilen versiyonu alır, rollout yüzdesi/major filter etkisiz kalır.',
    actionHistory: 'İşlem Geçmişi',
    time: 'Zaman',
    action: 'Aksiyon',
    affectedRows: 'Etkilenen satır',
    performedBy: 'Yapan',
    removeBulkGrant: 'Bulk Grant\'ı Kaldır',
    restorePrevious: 'Önceki Kaldırmayı Geri Yükle',
    restoreConfirm: '{n} kullanıcının kaldırılan bulk grant\'ı geri yüklenecek. Devam edilsin mi?',
    restoreConfirmTitle: 'Geri Yükleme Onayı',
    yesRestore: 'Evet, geri yükle',
    cancel: 'İptal',
    success: 'Başarılı',
    error: 'Hata',
    restoredSummary: '{users} kullanıcı, {rows} satır geri yüklendi',
    restoreFailed: 'Geri yükleme başarısız',
    revokeConfirm: '{n} kullanıcının bulk grant\'ı kaldırılacak. Devam edilsin mi?',
    revokeConfirmTitle: 'Bulk Grant Kaldırma Onayı',
    yesRemove: 'Evet, kaldır',
    removedSummary: '{users} kullanıcı, {rows} satır kaldırıldı',
    removeFailed: 'Kaldırma başarısız',
    matchingFetchFailed: 'Eşleşen kullanıcılar alınamadı',
    noMatchingUsers: 'Aktif filtreye uyan (bulk grant tutan) kullanıcı yok.',
    cappedNote: 'NOT: Üst sınıra ({n}) ulaşıldı, daha fazlası olabilir. Filtreyi daraltıp tekrar çalıştırın.',
    revokeAllConfirm: 'Aktif filtreye uyan {n} kullanıcının bulk grant\'ı kaldırılacak. Bu işlem sayfadaki seçimle sınırlı DEĞİLDİR; eşleşen herkesi kapsar. Devam edilsin mi?',
    yesRemoveAll: 'Evet, tümünü kaldır',
    removedAllSummary: '{users} kullanıcı, {rows} satır kaldırıldı (filtreye uyan {n} kullanıcı işlendi)',
    bulkRemoveFailed: 'Toplu kaldırma sırasında hata (kısmi olabilir)',
    verifyConfirm: '{n} kullanıcı \'incelendi\' olarak işaretlenecek ve listeden düşecek. Devam edilsin mi?',
    verifyConfirmTitle: 'İncelendi Onayı',
    yes: 'Evet',
    verifiedMessage: '{n} kullanıcı \'incelendi\' olarak işaretlendi',
    revokeOneConfirm: '{email} kullanıcısının bulk grant\'ı kaldırılacak. Onaylıyor musun?',
    revokeOneTitle: 'Tek Kullanıcı Kaldırma',
    removed: 'Kaldırıldı',
    restoreOneConfirm: '{email} için en son kaldırılan bulk grant geri yüklenecek. Onaylıyor musun?',
    restoredRows: '{n} satır geri yüklendi',
    detailLoadFailed: 'Detay yüklenemedi: {error}',
    allCanesUserScope: 'tüm bastonlar (user-scope)',
    removePinConfirm: '{version} pin\'i ({scope}) kaldırılacak. Onaylıyor musun?',
    removePinTitle: 'Pin Kaldırma',
    pinRemoved: 'Pin kaldırıldı',
    pinRemoveFailed: 'Pin kaldırılamadı: {error}',
    statusPending: 'Bekliyor',
    statusRevoked: 'Kaldırıldı (izleniyor)',
    statusRestored: 'Geri yüklendi',
    statusVerified: '✓ Doğrulandı',
    today: 'Bugün',
    yesterday: 'Dün',
    daysAgo: '{n} gün önce',
    weeksAgo: '{n} hafta önce'
  },
  campaigns: {
    featuresHelpIntro: 'Her feature için iki seçenekten birini kullanın:',
    durationDaysLabel: 'Süre (gün):',
    durationDaysHelp: 'Kullanıcı kampanyayı kullandığı anda bu kadar gün boyunca aktif olur.',
    fixedDateLabel: 'Belirli tarih:',
    fixedDateHelp: 'Kullanıcı ne zaman kullanırsa kullansın, feature bu tarihte sona erer (kampanyalı dönem sonu).',
    colDurationType: 'Süre Tipi',
    colValue: 'Değer',
    selectFeature: 'Feature seçin',
    modeDays: 'Gün',
    modeDate: 'Tarih',
    daysExample: 'ör. 14',
    daysUnit: 'gün',
    endDate: 'Bitiş tarihi',
    addFeature: 'Feature Ekle',
    featureDurationRequired: 'Her feature için süre (gün) ya da bitiş tarihi belirtilmeli',
    pastEndDateNotAllowed: 'Aktif kampanyada bitiş tarihi geçmiş olamaz. Süreyi gün olarak verin, ileri bir tarih seçin ya da kampanyayı pasif kaydedin.',
    durationDays: '{n} gün',
    untilDate: '{date} tarihine kadar'
  },
  subscriptionAudit: {
    devToolTitle: 'Geliştirici Aracı',
    devToolDescription: 'Bu sayfa Apple Server API + Google Play Developer API\'yi sorgulayarak abonelik kayıtlarını DB ile karşılaştırır. Read-only bir denetim aracıdır - hiçbir kullanıcı verisini değiştirmez. Yalnızca süper admin görebilir.',
    runNewAudit: 'Yeni Audit Çalıştır',
    lookbackDays: 'Geçmişe Bakış (gün)',
    maxSubs: 'Maks. Abonelik',
    startAudit: 'Audit Başlat',
    refreshSummary: 'Özeti Yenile',
    asyncNote: 'Audit asenkron çalışır. Apple/Google API çağrıları nedeniyle yüzlerce abonelik için birkaç dakika sürebilir. Bu süre içinde sayfayı yenileyebilir veya findings tablosunu izleyebilirsin.',
    recentRuns: 'Son Audit Run\'lar',
    started: 'Başlangıç',
    colFindings: 'Bulgu',
    open: 'Açık',
    openByType: 'Açık Bulgular (Türlere Göre)',
    type: 'Tip',
    count: 'Sayı',
    findingsTitle: 'Bulgular',
    openOnly: 'Sadece açıklar',
    filter: 'Filtrele',
    reset: 'Sıfırla',
    product: 'Ürün',
    expectedActual: 'Beklenen → Gerçek',
    storeDbExpiry: 'Store/DB Bitiş',
    storeStatus: 'Store Durum',
    date: 'Tarih',
    status: 'Durum',
    resolved: 'Çözüldü',
    markResolved: 'Çözüldü işaretle',
    details: 'Detay',
    findingDetails: 'Bulgu Detayı',
    auditStarted: 'Audit başlatıldı. Birkaç dakika sürebilir; özeti yenileyerek ilerlemeyi görebilirsin.',
    startFailed: 'Audit başlatılamadı',
    summaryLoadFailed: 'Özet yüklenemedi',
    findingsLoadFailed: 'Bulgular yüklenemedi',
    resolutionNote: 'Çözüm notu (opsiyonel):',
    markResolvedTitle: 'Çözüldü olarak işaretle',
    markedResolved: 'İşaretlendi'
  },
  common: {
    noData: 'Herhangi bir veri bulunmamaktadır.',
    invalidUserType: 'Kullanıcı tipi geçersiz.',
    invalidRequest: 'Geçersiz istek.',
    unauthorized: 'Yetkisiz erişim.',
    errorWithStatus: 'Hata: {status}',
    errorOccurred: 'Bir hata oluştu: {message}',
    sessionEnded: 'Oturumunuz kapatıldı.'
  },
  aimAnalytics: {
    title: 'AIM Analitik (BigQuery)',
    descIntro: 'Baston AIM okuma verisinin analitik özeti. Kaynak: BigQuery',
    descTable: '(önceden toplanmış gün/cihaz tablosu).',
    superAdminOnly: 'Yalnızca süper admin erişebilir.',
    overview: 'Genel Özet',
    totalReadings: 'Toplam Okuma',
    totalSessions: 'Toplam Oturum',
    devices: 'Cihaz',
    users: 'Kullanıcı',
    dataRange: 'Veri aralığı:',
    dayDeviceRecords: '({n} gün/cihaz kaydı)',
    monthlyTrend: 'Aylık Trend',
    month: 'Ay',
    readings: 'Okuma',
    sessions: 'Oturum',
    dailyTrend: 'Günlük Trend',
    lastNDays: 'Son {n} gün',
    day: 'Gün',
    mostActiveCanes: 'En Aktif Bastonlar',
    topN: 'İlk {n}',
    caneId: 'Baston (cane_id)',
    activeDays: 'Aktif Gün',
    lastDay: 'Son Gün',
    loadSummaryFailed: 'Özet yüklenemedi',
    loadDailyFailed: 'Günlük veri yüklenemedi',
    loadCanesFailed: 'Baston listesi yüklenemedi'
  },
  diagnostics: {
    title: 'Baston Tanılama (Diagnostics)',
    introSnapshots: 'Bastonlardan akan diagnostic snapshot\'lar (batarya, ultrasonik, engel algılama, fault register\'lar, firmware).',
    introUsage: 'Seri numarası girip o cihazın zaman serisini görebilir, ya da filtreyle tüm kayıtları listeleyebilirsin.',
    serialPlaceholder: 'Seri no (örn. WW-OZ-11267-000117)',
    source: 'Kaynak',
    sourceMobileApp: 'Mobil uygulama',
    sourceProductionPlatform: 'Üretim platformu',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    search: 'Ara',
    reset: 'Sıfırla',
    groupByCane: 'Bastona göre grupla',
    deviceLabel: 'Cihaz:',
    total: 'Toplam',
    caneUnit: 'baston | baston',
    snapshotUnit: 'snapshot | snapshot',
    latestPerCane: '(her baston için en son snapshot gösteriliyor)',
    received: 'Alındı',
    serialNo: 'Seri No',
    production: 'Üretim',
    mobile: 'Mobil',
    battery: 'Batarya',
    health: 'Sağlık',
    clean: 'Temiz',
    unregistered: 'Kayıtsız',
    unregisteredDevice: 'kayıtsız cihaz',
    snapshots: 'Snapshot\'lar',
    details: 'Detay',
    identity: 'Kimlik',
    registeredDevice: 'Kayıtlı cihaz',
    notRegistered: 'HAYIR (kayıtsız)',
    user: 'Kullanıcı',
    deviceTime: 'Cihaz zamanı',
    charge: 'Şarj',
    voltage: 'Voltaj',
    current: 'Akım',
    faultRegisters: 'Fault Register\'lar',
    obstacleDetection: 'Engel Algılama',
    ultrasonic: 'Ultrasonik',
    firmwareSystem: 'Firmware / Sistem',
    audio: 'Ses',
    rawPayload: 'Ham payload (hex)',
    snapshotDetails: 'Snapshot Detayı',
    loadFailed: 'Snapshot listesi yüklenemedi',
    uptimeHours: '{h}s {m}dk',
    uptimeMinutes: '{m}dk {s}sn'
  },
  callEvents: {
    answeredCalls: 'Yanıtlanan Çağrılar',
    missedCalls: 'Yanıtlanmayan Çağrılar',
    failedCalls: 'Sorunlu Çağrılar',
    failedCallsHint: 'Asistan paneline hiç düşmemiş gibi görünen çağrılar — Zoom oturumu hiçbir katılım almamış (caller bile bağlanamamış)',
    noSubject: 'Konu seçilmemiş',
    callId: 'Çağrı ID',
    diagnosis: 'Tanı',
    regionCandidates: 'Region eşleşen aday:',
    noRecordPrePhase2: 'kayıt yok (Faz 2 öncesi)',
    connectedAtTime: 'O an bağlı olan (broadcast atılan):',
    panelsCaughtNewCall: 'Panel\'in \'new-call\' yakaladığı:',
    hintNotConnected: 'Aday > 0, Bağlı = 0 → o anda hiçbir asistanın paneli WS\'ye bağlı değildi (broadcast hiç atılmadı)',
    hintPanelFailed: 'Bağlı > 0, Panel ack = 0 → soket vardı ama panel mesajı işleyemedi (UI/parse hatası, Glitchtip\'e bakın)',
    hintNoAccept: 'Panel ack > 0, Zoom = 0 → panel gördü ama hiçbir asistan kabul etmedi',
    diagNoRegionAssistant: 'Region eşleşen asistan yok',
    diagCandidatesNoneOnline: '{c} aday, hiçbiri online değildi',
    diagConnectedPanelFailed: '{n}/{c} bağlıydı, panel işleyemedi',
    diagPanelsSawNobodyOpened: '{a}/{n} panel gördü, kimse açmadı',
    diagPanelsSawNotAnswered: '{a}/{n} panel gördü, cevaplanmadı',
    diagPanelsSawJoins: '{a} panel gördü, {joined} katılım',
    diagSentNoneConnected: '{n} asistana iletildi, hiç bağlanma yok',
    diagSentNotAnswered: '{n} asistana iletildi, cevaplanmadı',
    diagNotifiedJoins: '{n} bildirim, {joined} katılım',
    diagLegacyNoJoins: 'Hiç katılım yok (eski kayıt)',
    diagLegacyOneSide: 'Sadece tek taraf (eski kayıt)',
    diagLegacyJoins: '{joined} katılım (eski kayıt)'
  },
  kpiAnalytics: {
    latestCombined: 'V2 latest + V3 latest birleşik',
    latestRowsHint: '— bu satırların hepsi "Latest" sayılır',
    channelBuildHint: 'beta grupları kendi build\'lerine göre değerlendirilir',
    registrationsInfo: 'Belirli tarih aralığında yeni üye olan (users.created_at) hesapların listesi. İsim, email, telefon, ülke bilgileri iletişim için kullanılabilir. Store install sayımlarıyla karıştırılmamalı — onlar anonim toplam.'
  },
  mobilityGroups: {
    trainerTraineeInfo: 'Öğretmen trainer, öğrenciler trainee olur. Öğretmen öğrencilerinin verisini görür. Öğrenci kendi verisini ve öğretmeninin verisini görür, diğer öğrencileri göremez. Bir öğrenci birden fazla öğretmene ait olabilir.'
  },
  otaFilesExtra: {
    stableAllUsers: 'Stable (Default) — tüm kullanıcılar',
    groupCreateHint: 'Boş bırak = stable (tüm filo). Bir grup seç = sadece o grubun üyeleri.',
    groupEditHint: 'Boş = stable (tüm filo). Grup build\'ini herkese açmak için burayı boşalt.',
    rolloutRandom: 'Rastgele (%)',
    rolloutFirstCome: 'İlk gelen (adet)',
    rolloutRandomHelp: 'Rastgele: userId hash\'ine göre sabit bir yüzdelik kitle alır (aynı kullanıcılar hep aynı grupta).',
    rolloutFirstComeHelp: 'İlk gelen: bu sürümü ilk isteyen N kullanıcı alır ve o sürümde kalır; sonrası bir önceki sürümde kalır.',
    firstNUsers: 'İlk kaç kullanıcı',
    firstNUsersHint: 'Bu sürümü alacak ilk kullanıcı sayısı (bir önceki aktif sürüm fallback olmalı)',
    rolloutFirstN: 'İlk {n}',
    totalRequests: 'Toplam İstek: {n}',
    groupCount: '{n} grup | {n} grup',
    exportToExcel: 'Excel\'e Aktar',
    lastRequest: 'Son İstek',
    firstAt: 'ilk: {date}',
    requests: 'İstek',
    userDevice: 'Kullanıcı / Cihaz',
    pinOnlyTagHint: 'Genele dağıtılmaz — sadece kullanıcıya pin\'lendiğinde inebilir',
    managePins: 'Pin Yönet',
    managePinsFor: 'Pin Yönet - {name}',
    pinnedUsers: 'Bu OTA\'ya pinli kullanıcılar',
    addNewPin: 'Yeni pin ekle',
    searchUserPlaceholder: 'Kullanıcı ara (isim, e-posta, telefon)',
    loadingUserDetails: 'Kullanıcı bilgileri yükleniyor...',
    noActiveDevice: 'Bu kullanıcının ACTIVE cihazı yok - pin atılamaz.',
    noOtaSelected: 'OTA seçili değil',
    noRecordsToExport: 'Aktarılacak kayıt yok',
    recordsExported: '{n} kayıt aktarıldı | {n} kayıt aktarıldı',
    excelExportFailed: 'Excel aktarımı başarısız: {error}',
    pinListLoadFailed: 'Pin listesi alınamadı: {error}',
    userDetailsLoadFailed: 'Kullanıcı bilgisi alınamadı: {error}',
    allCanesUserScope: 'tüm bastonlar (user-scope)',
    removePinConfirm: '{user} kullanıcısının {version} pin\'i ({scope}) kaldırılacak. Onaylıyor musun?',
    removePinTitle: 'Pin Kaldırma',
    confirmRemove: 'Evet, kaldır',
    cancel: 'İptal',
    pinRemoved: 'Pin kaldırıldı',
    pinRemoveFailed: 'Pin kaldırılamadı: {error}'
  },
  caneAudio: {
    introTitle: 'Baston ses paketleri',
    introBody: 'Uygulamanın bastona yazdığı ses setleri. Uygulama bu listeyi okur, seçilen dil ve sesin aktif sürümünü indirir, bastona yazmadan önce boyut ve sha256 kontrolü yapar. Yayınlanmış bir sürüm değiştirilmez; yeni ses için yeni sürüm yüklenir. Kullanıcıya her yuvanın yalnız aktif sürümü sunulur.',
    kind_generic: 'Generic set',
    kind_english_primary: 'Yerleşik İngilizce',
    kind_language: 'Dil paketi',
    kindHint_generic: 'Korna, zil, bip gibi konuşma dışı sesler. Sürümü, bastonun bildirdiği generic sürümüdür.',
    kindHint_english_primary: 'Birincil bankaya yazılan en-US kadın cümleleri; baston bunlara düşer.',
    versions: 'Sürümler',
    uploadVersion: 'Yeni sürüm yükle',
    upload: 'Yükle',
    download: 'indir',
    noActivePack: 'Aktif paket yok. Bir sürüm yüklenip aktif edilene kadar uygulama bunu kuramaz.',
    noPack: 'paket yok',
    searchPlaceholder: 'Kod, ad, klasör veya alias ara',
    showInactive: 'Pasif dilleri göster',
    refresh: 'Yenile',
    newLanguage: 'Yeni dil',
    languageCount: '{n} dil',
    code: 'Kod',
    displayName: 'Ad',
    backendKey: 'Backend anahtarı',
    otaFolder: 'Klasör',
    manifestPrefix: 'Manifest öneki',
    synthesisCode: 'TTS dili',
    aliases: 'alias',
    aliasesHelp: 'Cihazlarda kayıtlı eski kısa kodlar, virgülle (örn. tr)',
    voicesHelp: 'Yuva başına Google TTS sesi. Telefon bu sesle konuşur, paketteki sesle aynı olmalı. Sesi boş olan yuva kullanıcıya sunulmaz.',
    voicePlaceholder: 'örn. tr-TR-Chirp3-HD-Aoede (boş = yuva sunulmaz)',
    slot_female: 'Kadın 1',
    slot_female2: 'Kadın 2',
    slot_male: 'Erkek 1',
    slot_male2: 'Erkek 2',
    sortOrder: 'Sıra',
    active: 'Aktif',
    yes: 'Evet',
    no: 'Hayır',
    actions: 'İşlemler',
    edit: 'Düzenle',
    editLanguageTitle: '{code} dilini düzenle',
    close: 'Kapat',
    save: 'Kaydet',
    saved: 'Kaydedildi',
    required: 'Zorunlu',
    version: 'Sürüm',
    size: 'Boyut',
    uploadedAt: 'Yüklenme',
    note: 'Not',
    editNote: 'Notu düzenle',
    activate: 'Aktif yap',
    deactivate: 'Pasife al',
    versionsHint: 'Bir sürümü aktif yapınca aynı yuvanın diğer sürümleri pasife iner. Dosyalar depoda kalır, eski bir sürüm istendiğinde yeniden aktif yapılabilir.',
    uploadTitle: 'Paket sürümü yükle',
    packKind: 'Paket türü',
    language: 'Dil',
    voiceSlot: 'Ses yuvası',
    versionHelp: 'Üç sayı, major.minor.build (örn. 2026.11.01). Bastona üç 32 bit sayı olarak yazılır; harf olamaz.',
    zipFile: 'Zip dosyası',
    zipHelp: 'Zip kökünde manifest.json ve ses dosyaları, başka bir şey yok. Sunucu kabul etmeden önce her dosyanın adını ve boyutunu manifestle, adres zincirini de kuralla karşılaştırır.',
    uploadRejected: 'Paket kabul edilmedi',
    uploaded: 'Yüklendi ve aktif edildi',
    failed: 'Olmadı'
  }
}
